import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../../buttons/Button'
import CustomModal from '../../../../modal/CustomModal'
import { useTranslation } from 'react-i18next'
import { InvoiceCompactWrap, InvoiceLabelBill, InvoiceLabelText, InvoiceSheetWrap, InvoiceStatusBar } from './index.styled'
import MainIcon from '../../../../../../img/svg/main'
import { setShowInvoiceDataModal, setShowInvoiceOptionsModal } from '../../../../../../redux/action/invoice'
import { getInvoiceViewStatus, INVOICE_STATUS } from '../../constants'
import CanceledInvoiceIcon from '../CanceledInvoiceIcon'
import InvoiceSheet from '../InvoiceSheet'
import { useWindowBreakPoint } from '../../../../../../hooks/useWindowBreakPoint'
import { theme } from '../../../../../../style/theme'
import { getSheetLayout } from './helper'

const EVENT_Z_INDEX = 81

const InvoiceDataModal = React.memo(({ handlePrint }) => {
	const { t } = useTranslation()
	const invoice = useSelector(store => store.invoice.selectedInvoice)
	const showInvoiceDataModal = useSelector(store => store.invoice.modal.showInvoiceData)
	const dispatch = useDispatch()
	const isCompact = useWindowBreakPoint(theme.point1280)
	const isMobile = useWindowBreakPoint(theme.point720)
	const layout = getSheetLayout(isMobile, isCompact)
	const viewStatus = getInvoiceViewStatus(invoice)
	const isPaid = viewStatus === INVOICE_STATUS.PAID
	const isCanceled = viewStatus === INVOICE_STATUS.CANCELED
	const paymentLayoutLabel = isPaid ? 'green' : 'orange'
	const layoutLabel = isCanceled ? 'canceled' : paymentLayoutLabel
	const paymentLabelText = isPaid ? t('invoices.modal.invoiceDataModal.paid') : t('invoices.modal.invoiceDataModal.unpaid')
	const labelText = isCanceled ? t('invoices.modal.invoiceDataModal.canceled') : paymentLabelText
	const statusIcon = isCanceled ? <CanceledInvoiceIcon /> : <MainIcon icon={isPaid ? 'paidInvoice' : 'unpaidInvoice'} />

	const handleClose = useCallback(() => {
		dispatch(setShowInvoiceDataModal(false))
		dispatch(setShowInvoiceOptionsModal(true))
	}, [dispatch])

	return (
		<CustomModal isOpen={showInvoiceDataModal}
								 close={handleClose}
								 title={t('invoices.modal.invoiceDataModal.titleNumber', { number: invoice.invoiceNumber })}
								 titleUpperCase={!isCompact}
								 size="medium height-scroll"
								 id="invoice-data-modal"
								 zIndex={EVENT_Z_INDEX}
								 disableBackButton={true}
								 button={
									 <>
										 <Button name="cancel" icon="clear" text={t('buttons.controls.cancel_1')}
														 keyButton="F3" zIndex={EVENT_Z_INDEX}
														 onClick={handleClose}
														 className="back" />
										 <Button name="print" color="green" icon="print" text={t('buttons.controls.print')}
														 keyButton="F2" zIndex={EVENT_Z_INDEX}
														 onClick={handlePrint} />
									 </>
								 }>
			{isCompact ?
				<InvoiceCompactWrap>
					<InvoiceStatusBar className={layoutLabel}>
						{statusIcon}
						<InvoiceLabelText>{labelText}</InvoiceLabelText>
					</InvoiceStatusBar>
					<InvoiceSheet invoice={invoice} t={t} layout={layout} />
				</InvoiceCompactWrap> :
				<InvoiceSheetWrap>
					<InvoiceLabelBill className={layoutLabel}>
						{statusIcon}
						<InvoiceLabelText>{labelText}</InvoiceLabelText>
					</InvoiceLabelBill>
					<InvoiceSheet invoice={invoice} t={t} layout={layout} />
				</InvoiceSheetWrap>}
		</CustomModal>
	)
})

InvoiceDataModal.displayName = 'InvoiceDataModal'
export default InvoiceDataModal
